import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CartPromoAdd from '@/plugins/graphql/mutations/v2/cart-promo-create.gql';
import CartPromos from '@/plugins/graphql/queries/v2/cart-promos.gql';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import CartPromoMixin from '@/helpers/vue_mixins/v2/ecommerce/CartPromoMixin';
import CartPromoForm from '@/components/v2/CartPromoForm.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CartPromoCreate = class CartPromoCreate extends mixins(AlertMixin, RouterParamsAppMixin, CartPromoMixin, CleverTapEventsMixin) {
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            const msg = successfulCreate('Cart Promo');
            this.cartPromoAction('SUBMIT CREATE');
            this.successNotification(msg);
            this.goToCartPromosPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    freebieUuids(form) {
        return form.freebies.map((freebie) => {
            return freebie.uuid;
        });
    }
    async create(form) {
        const appUuid = this.appUUID;
        const { requiredAmount, promoType, discountType, value, paymentOptions } = form;
        await this.$apollo.mutate({
            mutation: CartPromoAdd,
            variables: {
                input: {
                    requiredAmount,
                    promoType,
                    discountType,
                    active: true,
                    value,
                    productUuids: this.freebieUuids(form),
                    appUuid,
                    paymentOptions,
                },
            },
            // update(cache: any, { data }: any) {
            //   const queryOptions = {
            //     query: CartPromos,
            //     variables: {
            //       appUuid,
            //     },
            //   };
            //   const { fetchAllCartPromo } = cache.readQuery({
            //     ...queryOptions,
            //   });
            //   if (!fetchAllCartPromo) {
            //     return;
            //   }
            //   const cachedCartPromos = {
            //     ...fetchAllCartPromo,
            //   };
            //   cachedCartPromos.edges.unshift({
            //     node: data.cartPromoAdd.cartPromo,
            //   });
            //   cache.writeQuery({
            //     ...queryOptions,
            //     data: {
            //       fetchAllCartPromo: cachedCartPromos,
            //     },
            //   });
            // },
            refetchQueries: [
                {
                    query: CartPromos,
                    variables: {
                        appUuid,
                        first: 10,
                        after: null,
                    },
                },
            ],
        });
    }
};
CartPromoCreate = __decorate([
    Component({
        components: {
            PageTitle,
            CartPromoForm,
        },
    })
], CartPromoCreate);
export default CartPromoCreate;
